import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ImageUploadService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.backend}/files`;

  uploadProfilePicture(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    // Wichtig: Wir senden hier keinen JSON-Header
    return this.http.post(`${this.apiUrl}/upload-profile-picture`, formData);
  }

  uploadRestStopPicture(file: File, restStopId: number) {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(`${this.apiUrl}/upload-reststop-picture/${restStopId}`, formData);
  }
}
